export enum DrugTestResult {
	Positive = 1,
	Negative = 2,
	NoResult = 3,
	NoShow = 4,
	Excused = 5,
	Diluted = 6,
	ConsistentWithMeds = 7,
	Presumptive = 8,
}